'use strict';

/**
 *  Load modules
 */
import burgerMenu from './modules/burgerMenu.js';
import video from './modules/video.js';
import swiper from './modules/swiper.js';
import magnificPopup from './modules/magnific-popup.js';
import openClose from './modules/openClose.js';
import anchorLinks from './modules/anchorLinks.js';
import accordion from './modules/accordion.js';
import externalLinks from './modules/externalLinks.js';
import postsPage from './modules/postsPage.js';
import '../scss/app.scss';
$(document).ready(function () {});